import { useLocation } from "@tanstack/react-router";
import { Sheet, SheetContent } from "@/ui/sheet";
import { SidebarContent } from "./SidebarContent";
import { useSidebarData } from "./useSidebarData";
import { useScrollActiveNavIntoView } from "./sidebar/scroll-active-into-view";

/**
 * `alsoDesktop`: ngăn kéo menu đầy đủ mở được cả trên máy tính — cho màn thay
 * cột menu bằng dải biểu tượng. Chat khách từng dùng (QĐ 0223) và đã bỏ dải
 * 15/10/2026 (QĐ 0374), nay không màn nào bật.
 */
export function MobileDrawer({
  open,
  onOpenChange,
  alsoDesktop = false,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  alsoDesktop?: boolean;
}) {
  const { identity, role, visibleGroups, pendingCount, customerBookingPendingCount, chatWaitingCount, notificationUnreadCount } =
    useSidebarData();
  // Ngăn kéo chỉ dựng nội dung lúc mở, nên `open` phải nằm trong khoá: mở lại
  // là một lần gắn phần tử mới, cần cuộn lại tới mục đang mở.
  const { pathname, searchStr } = useLocation();
  const scrollerRef = useScrollActiveNavIntoView<HTMLDivElement>(`${open}|${pathname}${searchStr}`);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        ref={scrollerRef}
        side="left"
        className={`flex w-[280px] flex-col overflow-y-auto scrollbar-on-brand p-0 ${alsoDesktop ? "" : "md:hidden"} [&>button]:text-white/95 [&>button]:hover:text-white`}
        style={{ background: "var(--gn-sidebar-bg)", color: "rgba(255,255,255,0.75)" }}
      >
        <SidebarContent
          identity={identity}
          role={role}
          visibleGroups={visibleGroups}
          pendingCount={pendingCount}
          customerBookingPendingCount={customerBookingPendingCount}
          chatWaitingCount={chatWaitingCount}
          notificationUnreadCount={notificationUnreadCount}
          onNavigate={() => onOpenChange(false)}
        />
      </SheetContent>
    </Sheet>
  );
}
